/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：341
 */

module.exports = {
  SoundLayoutItem: "style_SoundLayoutItem__zbnsH",
  delete: "style_delete__1V7tf",
  active: "style_active__qbelG",
  soundBoxWrapper: "style_soundBoxWrapper__235M_",
  soundBox: "style_soundBox__2ShzU",
  soundIconBox: "style_soundIconBox__30IVm",
  soundDefaultIcon: "style_soundDefaultIcon__3vluC",
  soundPlayIconBox: "style_soundPlayIconBox__3eAcj",
  soundPauseIconBox: "style_soundPauseIconBox__1Dpeh",
  progressWrapper: "style_progressWrapper__3f1vp",
  rightWrapper: "style_rightWrapper__Ym2OT",
  leftWrapper: "style_leftWrapper__3SNAp",
  circleProgress: "style_circleProgress__I_YFr",
  rightCircle: "style_rightCircle__3XzDn",
  circleProgressLoad_right: "style_circleProgressLoad_right__3LUVg",
  leftCircle: "style_leftCircle__205rn",
  circleProgressLoad_left: "style_circleProgressLoad_left__2b_H8",
  fileItemName: "style_fileItemName__Y1rDI",
  soundDuration: "style_soundDuration__2MjES"
}
